const inputFields = [
  'quantity_total_new',
  'quantity_total_recovered',
  'quantity_feedstock',
  'quantity_for_destruction',
  'quantity_article_5',
  'quantity_feedstock',
  'quantity_total_produced',
  'quantity_destroyed',
  'remarks_party',
  'remarks_os',
  'quantity_import_new',
  'quantity_import_recovered',
  'quantity_export_new',
  'quantity_export_recovered',
  'facility_name',
  'quantity_generated',
  'quantity_feedstock',
  'quantity_destroyed',
  'quantity_emitted',
  'quantity_captured_all_uses',
  'quantity_captured_all_uses_excluding_feedstock',
  'quantity_captured_feedstock',
  'quantity_captured_for_destruction',
  'quantity_stored_beginning_year',
  'quantity_stored_end_year'
]
export default inputFields
